/* ======================================================================== */
/* 14. PJAX Update Body Classes */
/* ======================================================================== */
function PJAXUpdateBodyClasses(data) {

	return new Promise(function (resolve, reject) {

		var
			regexp = /\<body.*\sclass=["'](.+?)["'].*\>/gi,
			match = regexp.exec(data.next.html);

		if (!match || !match[1]) {
			return;
		}

		document.body.setAttribute('class', match[1]);

		resolve(true);

	});

}
